export const ADMIN = 'Admin';
export const CLINIC_ADMIN = 'ClinicAdmin';
export const CLINIC_PROVIDER = 'Provider';
